export default "<ion-app >\n  <ion-router-outlet class=\"safeFitApp\"></ion-router-outlet>\n</ion-app>\n";